var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-quantity"},[_c('label',[_vm._v(_vm._s(_vm.$t('checkout.labelQuantity')))]),_vm._v(" "),_c('p',[_c('count',{attrs:{"number":_vm.number},on:{"change":_vm.changeNum}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }